import { Component, DestroyRef, EventEmitter, inject, Input, Output } from '@angular/core';
import { RelationshipTypesLabels } from '@app/modules/relation-relation/enum/relationship-types.enum';
import { RelationRelationTableItemModel } from '@app/modules/relation-relation/models/relation-relation-table.model';
import { ClaimTypes, ClaimValues } from '@app/shared/models/common/constants';
import { TableStateModel } from '@app/shared/models/table/table-state.model';

@Component({
    selector: 'app-relation-relation-overview-table',
    templateUrl: './relation-relation-overview-table.component.html',
    styleUrls: ['./relation-relation-overview-table.component.less'],
})
export class RelationRelationTablePartComponent {
    @Input({ required: true }) data: TableStateModel<RelationRelationTableItemModel>;

    @Output() create = new EventEmitter<void>();
    @Output() delete = new EventEmitter<number>();

    @Output() getRelation = new EventEmitter<number>();
    @Output() resetOverview = new EventEmitter<void>();

    destroyRef = inject(DestroyRef);

    relationshipTypeMapping = RelationshipTypesLabels;

    ClaimTypes = ClaimTypes;
    ClaimValues = ClaimValues;
    draggingEnabled = false;
}
